import { useEffect } from "react";
import { registerWorkspaceHeader } from "../../lib/nav";
import { useProjectAddress } from "../../shell/project";
import { taskNavigation } from "../../workspaces/projects/task-navigation";
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_console/p/$org/$project/tasks")({
  component: ProjectPlanRoute,
});

function ProjectPlanRoute() {
  const address = useProjectAddress();
  useEffect(() => registerWorkspaceHeader({ workspace: "projects", items: taskNavigation(address), presentation: "tabs" }), [address]);
  return <Outlet />;
}
